<template>
    <div class="Contact flex-center color-f5f1e9" ref="Contact">
      <div class="Contact-container" >
        <h2 class="contact-title text-left light color-f2ddc8">
        CONTACT US
        </h2>
        <div class="w100 flex-row flex-between">
          <div class="contact-left">
            <img class="w100" @click="openUrl()" src="@/assets/contact-map.png" alt="">
            <!-- <div class="f14 text-left">Sales gallery now open at the junction of 
              Bukit Batok West Ave 3 and Ave 8</div>
            <div class="f14 text-left m-t-5">
              Open weekdays from 11am - 8pm
              <br>
            Open weekends from 10am - 7pm
            </div> -->
          </div>
          <div class="Contact-data w70">
            <form action="" method="post" class="Contact-form" data-aos="fade-in">
              <div class="Contact-input-text w100">
                <input
                  class="input-text input-left"
                  style="text-transform: uppercase"
                  type="text"
                  placeholder="FIRST NAME"
                  v-model="FirstName"
                  required
                />
                <input
                  class="input-text input-right"
                  style="text-transform: uppercase"
                  type="text"
                  placeholder="LAST NAME"
                  v-model="LastName"
                  required
                />
              </div>
              <div class="Contact-input-text w100">
                <input
                  class="input-text input-left"
                  type="text"
                  placeholder="MOBILE"
                  v-model="Mobile"
                  required
                />
                <input
                  class="input-text input-right"
                  type="text"
                  placeholder="EMAIL"
                  v-model="Email"
                  required
                />
              </div>
              <div class="Contact-input-text w100 light select-group">
                <div class="select-title ">UNIT TYPES I AM INTERESTED IN:</div>
                <div class="Contact-type">
                  <label v-for="i in typeList" :key="i">
                    <input
                      type="checkbox"
                      name="interest"
                      :value="i"
                      v-model="selectType"
                    />
                    <span>{{ i }}</span>
                  </label>
                </div>
              </div>
              <textarea
                placeholder="MESSAGE (OPTIONAL)"
                class="Contact-text"
                v-model="Message"
              ></textarea>
              <div class="contact-PRIVACY text-left" >YOUR PRIVACY IS IMPORTANT TO US.</div>
              <div
                style="align-items: flex-start"
                class="Send-type w100"
                @click="SendType = !SendType"
              >
                <input type="checkbox" name="interest" :checked="SendType" />
                <p class="Clause">
                  I give consent to representatives of Otto Place EC to contact me regarding news, updates, registration, and everything 
                  pertaining to Otto Place EC, thereby overriding any registration on the DNC Registry, if applicable.
                </p>
              </div>
            </form>
            <button class="Send m-t-20" @click="SendEmail">
              <span class="Send-bg"></span>
              <span class="Send-text">SUBMIT</span>

            </button>
            <!-- <input
              @click="SendEmail"
              class="Send"
              value="SUBMIT"
              id="submit"
              type="submit"
            /> -->
          </div>
        </div>
      </div>
      <div class="Pop-win flex-center" v-show="SendPopType">
        <div class="Pop-Bg" @click="SendPopType = !SendPopType"></div>
        <div class="Send-ok-pop flex-column flex-center">
          <h2 class="Send-ok-pop-title">
            <!-- THANK YOU
            <div class="phone-LineBreak"></div>
            FOR YOUR INTEREST -->
            THANK YOU FOR YOUR INTEREST
          </h2>
          <p>We’ll be in touch closer to launch.</p>
          <div class="Pop-x" @click="SendPopType = !SendPopType">X</div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import md5 from 'js-md5';
  
  export default {
    data() {
      return {
        FirstName: "",
        LastName: "",
        Mobile: "",
        Email: "",
        UnitType: "",
        Message: "",
        SendType: false,
        typeList: ["3BR","3BR + STUDY","4BR + STUDY"],
        selectType: [],
        SendPopType: false,
      };
    },
    mounted() {},
    methods: {
      openUrl(){
            // window.open('https://www.google.com/maps/place/Otto+Place+(U%2FC)/@1.3475302,103.7345453,1024m/data=!3m2!1e3!4b1!4m6!3m5!1s0x31da11006ae8c975:0xeb2bb7ed8e14c70a!8m2!3d1.3475302!4d103.7371202!16s%2Fg%2F11x7yts37b?entry=ttu&g_ep=EgoyMDI1MDYxNi4wIKXMDSoASAFQAw%3D%3D', '_blank');
            window.open('https://www.google.com/maps/place/Novo+Place+EC+Showroom/@1.3491195,103.734326,791m/data=!3m2!1e3!4b1!4m6!3m5!1s0x31da11d59c7fd4e7:0xe37baca419be513e!8m2!3d1.3491141!4d103.7391969!16s%2Fg%2F11wpnmsfd4?entry=ttu&g_ep=EgoyMDI1MDYyNi4wIKXMDSoASAFQAw%3D%3D', '_blank');
        },
      objKeySort(obj) {
        //排序的函数
        //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
        let newkey = Object.keys(obj).sort();
        let newObj = {}; //创建一个新的对象，用于存放排好序的键值对
        for (let i = 0; i < newkey.length; i++) {
          //遍历newkey数组
          newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
        }
        return newObj; //返回排好序的新对象
      },

      SendEmail() {
        
        // return;
        // 邮件发送
        if (!this.Email) {
          alert("Please fill in your e-mail address.");
          return;
        } else if (this.SendType) {
          let content = `Hello, you have a message from the website (https://mixgovr.com/WEB/OTTO/).<br/>FirstName:${this.FirstName},<br/>LastName:${this.LastName},<br/>Mobile:${ this.Mobile },<br/>Email:${this.Email},<br/>Unit Type:${this.selectType.join( ",")},<br/>Message:${this.Message}`;
          
          let data = {
            name: "Arina East",
            // email: "aer@zacdgroup.com",
            email: "aer@zacdgroup.com",
            content: content,
          };
          var str = "";
          for (const key in this.objKeySort(data)) {
            if (
              this.objKeySort(data)[key] !== null &&
              typeof this.objKeySort(data)[key] !== "undefined"
            ) {
              str += this.objKeySort(data)[key];
            }
          }
          console.log(str + "c1d65f3667324592a071ebec5038f38c");
          
          let signature = md5(str + "c1d65f3667324592a071ebec5038f38c"); //请求签名
          console.log(signature);
          
          const formData = new FormData();
          formData.append("name", "Arina East");
          formData.append("email", "aer@zacdgroup.com");
          formData.append("content", content);
          formData.append("signature", signature);
  
          // 邮件发送
          this.$http
            .post(
              "https://api.singmap.com/manager-service/other/sendMailByCc1",
              formData
            )
            .then((response) => {
              if (response.data.code == "0") {
                // 发送成功清除输入内容！
                this.SendPopType = true;
                this.FirstName = "";
                this.LastName = "";
                this.Mobile = "";
                this.Email = "";
                this.Message = "";
                this.selectType = [];
                this.SendType = false;
              } else {
                alert("Email sending exception.");
              }
              console.log(response);
            });
        } else {
          alert("Please agree and check the content.");
        }
      },
    },
  };
  </script>
  
  
  <style lang="less">

  .phone-none{
    display: block;
  }
  .flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .Pop-Bg{
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
  }

  input:focus,textarea:focus{
    outline: none;
  }
  // .Contact {
  //   color: #f5f1e9;
  //   width: 100%;
  //   background-image: url("~@/assets/bg1.png");
  //   background-size: 100% 100%;
  // }
  
  .Contact-container{
    background-color: #666b50;
    margin: 12vh auto;
    padding: 70px 50px;
    width: 70%;
  }
  .contact-left{
    width: 25%;
  }
  .contact-title{
    // text-align: center;
    font-size: 36px;
    margin-bottom: 45px;
    // font-weight: 400;
    // display: flex;
    // justify-content: center;
  }
  .Contact-data {
    // margin: 10vh auto;
    // padding: 35px;
    // background-color: #a98c59e5;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 80%;
    // margin-left: 50px;
  }
  .phone-LineBreak {
    display: none;
  }
  .Contact-form {
    width: 100%;
  }
  .Contact-input-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin: 20px 0;
    margin-bottom: 20px;
  }
  .Contact-data input {
    color: #f5f1e9;
    border: 1px solid #f2ddc8; /* 边框颜色 */
    background-color: transparent; /* 背景透明 */
    padding-left: 1rem;
    font-weight: 400;
    letter-spacing: 1px;

  }
  .input-text {
    /* width: 46%; */
    height: 35px;
    border-radius: 1px;
  }
  .input-right {
    width: 68%;
  }
  .input-left {
    width: 25%;
  }
  .Contact-text {
    width: calc(100% - 44px);
    height: 10vh;
    background-color: #00000000;
    border: 1px solid #f2ddc8;
    border-radius: 1px;
    padding: 20px;
    color: #f5f1e9;
    font-weight: 400;
  }
  .Contact-data input::placeholder {
    color: #f5f1e9;
    margin-left: 5px;
  }
  .Contact-data textarea::placeholder {
    color: #f5f1e9;
    margin-left: 5px;
  }
  .Checkbox-title {
    font-weight: 400;
    text-align: start;
    font-size: 0.8rem;
  }
  .contact-PRIVACY{
    margin-top: 10px;
    font-size: 18px;
    font-weight: 400;
  }
  .Contact-type {
    display: flex;
    margin-left: 30px;
    // font-size: .7rem;
    // margin-left: 10px;
    // width: calc(57% + 1rem);
  }
  .Contact-type label {
    // font-size: 0.6rem;
    display: flex;
    align-items: center;
    /* margin: 5px 0; */
    margin-right: 1rem;
    white-space: nowrap;
  }
  .select-group{
    font-size: 14px;
    justify-content: start;
    // align-items: start;
  }
  .select-title {
    margin-right: 10px;
    // margin-bottom: 20px;
    // font-size: 0.6rem;
    // margin-left: 1rem;
  }
  input[type="checkbox"] {
    appearance: none; /* 去掉默认样式 */
    width: 24px; /* 设置宽度 */
    height: 24px; /* 设置高度 */
    border: 1px solid #fff; /* 白色边框 */
    background-color: transparent; /* 透明背景 */
    cursor: pointer; /* 鼠标指针样式 */
    padding: 0;
    margin: 0;
    margin-right: 5px;
    border-radius: 1px;
  }
  input[type="checkbox"]:checked {
    content: "5";
    background-color: white; /* 选中时背景色 */
    border: 2px solid white; /* 选中时边框颜色 */
  }
  textarea {
    resize: none;
  }
  
  .Send-type {
    display: flex;
    justify-content: space-around;
    text-align: start;
    margin: 20px 0;
  }
  .Clause {
    width: 97%;
    font-size: 16px;
    line-height: 22px;
    font-weight: 300;
    margin: 0;
  }
  .Send {
    position: relative;
    background: #00000000 !important;
    color: #f5f1e9;
    font-size: 16px;
    border: 1px solid #f2ddc8;
    padding: 10px;
    letter-spacing: 5px;
    cursor: pointer;
    // border-radius: 5px;
    width: 30%;
    height: 40px;
    margin: auto;
    font-weight: 400;
    /* font-weight: 200 !important; */
    // font-weight: normal;
    .Send-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #3e4037;
      transform: scaleX(0);
      transform-origin: center;
      transition: transform 0.3s ease;
      z-index: 1;
    }

    &:hover {
      .Send-bg{
        transform: scaleX(1);
      }
    }
    .Send-text{
      position: absolute;
      z-index: 2;
      transform: translate(-50%, -50%);
      color: #f5f1e9;
    }
    &::after{
      position: absolute;
      right: -50px;
      top: -19px;
      content: '';
      display: block;
      width: 51px;
      height: 40px;
      // border-left: 1px solid #fff;
      // border-bottom: 1px solid #fff;
      background-image: url('~@/assets/btn/btn-right.png');
      background-position: center;
      background-size: cover;
    }
    &::before{
      position: absolute;
      left: -50px;
      bottom: -19px;
      content: '';
      display: block;
      width: 51px;
      height: 40px;
      // border-right: 1px solid #fff;
      // border-top: 1px solid #fff;
      background-image: url('~@/assets/btn/btn-left.png');
      background-position: center;
      background-size: cover;
      // margin-right: 5px;
      // background-color: #666b50;
    }
  }


  .Pop-win {
    position: fixed !important;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  .Send-ok-pop {
    width: 70%;
    height: 200px;
    position: relative;
    background-color: #666b50;
    color: white;
    padding: 30px;
    text-align: center;
  }
  .Send-ok-pop-title {
    letter-spacing: 5px;
    font-weight: 500;
  }
  .Send-ok-pop p {
    font-size: 16px;
  }
  .Pop-x {
    width: 25px;
    position: absolute;
    right: 30px;
    top: 30px;
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
  }
  
  
  @media (max-width: 900px) {
    
    .phone-none{
      display: none;
    }
    .contact-left{
      width: 100%;
    }
    .Contact{
      .Contact-container{
        padding: 30px;
        width: 90%;
      }
      .flex-row{
        flex-flow: column;
      }
      .cantant-left,.Contact-data,.Contact-form{
        width: 100% !important;
      }
      .Contact-data{
        margin-top: 20px;
        margin-left:0;
        .flex-start{
          flex-direction: column;
          align-items: flex-start;
        }
        .Contact-input-text{
          flex-direction: column;
        }
        .input-text{
          width: calc(100% - 20px) !important;
          padding-left: 10px !important;
          margin: 10px 0;
          font-size: 10px;
          height: 30px;
        }
        .Contact-type{
          margin-top: 5px;
          margin-left: 0;
          font-weight: 300;
          label{
            margin-top: 5px;
          }
        }
        .Contact-text{
          letter-spacing: 1px;
          font-size: 10px;
          width: calc(100% - 24px);
          height: 15vh;
          padding: 10px;
          font-weight: 400;
        }
        .Send{
          width: 200px;
          height: 50px;
          font-size: 14px;
          letter-spacing: 2px;
        }
      }
      // .font14{
      //   font-size: 10px;
      // }
    }
  }
  
  
@media screen and (max-width:800px) {
  // .Contact-type{
  //   flex-direction: column;
  // }
  .Contact-input-text{
    margin-bottom: 0px !important;
  }
  .contact-PRIVACY{
    font-size: 11px;
  }
  .select-group{
    align-items: start !important;
    margin: 24px 10px !important;
  }
  .select-title{
    font-size: 12px;
  }
  .contact-title{
    font-size: 25px;
    margin-bottom: 15px;
    
  }
  .Contact {
    background-image: none;
  }
  .Contact-container{
    margin: 5%;
  }
}
  
  </style>
  
  
  
  
  
  
  
  
  
  
  
  
  